export const DatePickerSetup = ['date']
